import { render, staticRenderFns } from "./Vercirugia.vue?vue&type=template&id=c30f934c"
import script from "./Vercirugia.vue?vue&type=script&lang=js"
export * from "./Vercirugia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports